import { Card } from '../ui/Card';
import { fmt, fmtInt } from '../../lib/format';
import type { CalculatorResults, CalculatorInputs } from '../../lib/types';

interface Props {
  inputs: CalculatorInputs;
  results: CalculatorResults;
}

export function PMICard({ inputs, results }: Props) {
  const { pmiInfo, ltv, monthlyPMI, monthsUntilLTV80, loanAmount } = results;

  // Show card if there's a PMI rate or if we have a note, or if conventional and LTV ≤ 80
  const showCard = pmiInfo.rate > 0 || pmiInfo.note || (inputs.loanType === 'conventional' && ltv <= 80);
  if (!showCard) return null;

  return (
    <Card title="Mortgage Insurance / PMI">
      {ltv <= 80 && inputs.loanType === 'conventional' ? (
        <p style={{ color: 'var(--green)', fontWeight: 600 }}>
          No PMI required! Your LTV is {ltv.toFixed(1)}%.
        </p>
      ) : (
        <>
          <p style={{ fontWeight: 600, marginBottom: '0.5rem' }}>{pmiInfo.label}</p>
          <p style={{ fontSize: '0.85rem' }}>
            LTV: {ltv.toFixed(1)}% — Monthly: ${fmt(monthlyPMI)}
          </p>
          {pmiInfo.note && (
            <div className="note-box pmi-warning" style={{ marginTop: '0.75rem' }}>
              {pmiInfo.note}
            </div>
          )}
          {inputs.loanType === 'conventional' && ltv > 80 && (
            <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginTop: '0.5rem' }}>
              PMI drops off at ~${fmtInt(inputs.homePrice * 0.80)} balance ({monthsUntilLTV80} months)
            </p>
          )}
        </>
      )}
    </Card>
  );
}
